import { CldImage } from "next-cloudinary";
import styles from "./InfoCard.module.scss";

export default function InfoCard({ title, text, imageUrl, imageAlt }) {
  return (
    <article className={`${styles.infoCard} wn-info-card`}>
      {imageUrl && (
        <div className={`${styles.imageWrapper}`}>
          <CldImage
            src={imageUrl}
            fill
            alt={imageAlt || title}
            className={styles.image}
          />
        </div>
      )}

      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <p className={styles.text}>{text}</p>
      </div>
    </article>
  );
}
